 export enum Role {
  SchoolAdmin = 'school_admin',
  Manager = 'manager',
  Supervisor = 'supervisor',
  Teacher = 'teacher',
  Security = 'security',
  SharedGateScanner = 'shared_gate_scanner',
  Gate = 'gate',
  Cafeteria = 'cafeteria',
}

export enum Permission {
  // Students
  StudentAdd = 'StudentAdd',
  StudentDelete = 'StudentDelete',
  StudentEditNationalId = 'StudentEditNationalId',
  StudentEditGrade = 'StudentEditGrade',
  StudentEditClass = 'StudentEditClass',
  StudentBulkUpdateGradeClass = 'StudentBulkUpdateGradeClass',
  StudentEditName = 'StudentEditName',
  StudentEditGender = 'StudentEditGender',
  ViewStudentPhone = 'ViewStudentPhone',
  ViewStudentNationalId = 'ViewStudentNationalId',

  // Parents
  ParentAdd = 'ParentAdd',
  ParentDelete = 'ParentDelete',
  ParentEditPhone = 'ParentEditPhone',
  ParentEditNationalId = 'ParentEditNationalId',
  ParentEditName = 'ParentEditName',
  ParentEditGender = 'ParentEditGender',
  ViewParentPhone = 'ViewParentPhone',
  ViewParentNationalId = 'ViewParentNationalId',

  // Workflow
  AcceptNewAdditions = 'AcceptNewAdditions',
  RejectNewAdditions = 'RejectNewAdditions',
  editInfoNewAdditions = 'editInfoNewAdditions',
  UploadStudentsSheet = 'UploadStudentsSheet',
  UploadStaffSheet = 'UploadStaffSheet',

  // Assistants
  AssistantAdd = 'AssistantAdd',
  AssistantEdit = 'AssistantEdit',

  // Staff
  StaffAdd = 'StaffAdd',
  StaffEdit = 'StaffEdit',
  StaffDelete = 'StaffDelete',
  StaffManageSchoolAdmin = 'StaffManageSchoolAdmin',

  // Attendance
  // Mirrors the backend `administrate_or_manage_school` gate (admin, school_admin, section_manager).
  // Manager is deliberately NOT given it: the view-attendance endpoints return 403 for managers.
  ViewAttendance = 'ViewAttendance',
}

export const ROLE_PERMISSIONS: Record<Role, ReadonlySet<Permission>> = {
  [Role.SchoolAdmin]: new Set<Permission>(
    Object.values(Permission)
    // Object.values(Permission).filter(p => p !== Permission.StudentAdd)
  ),

  [Role.Manager]: new Set<Permission>([
    // Allowed per requirements
    Permission.StudentBulkUpdateGradeClass,
    Permission.StudentEditGrade,
    Permission.StudentEditClass,
    Permission.StudentEditName,

    Permission.ParentEditName,

    Permission.ViewStudentPhone,
    Permission.ViewStudentNationalId,
    Permission.ViewParentPhone,
    Permission.ViewParentNationalId,

    Permission.StudentEditGender,
    Permission.ParentEditGender,

    Permission.AssistantAdd,
    Permission.AssistantEdit,

    // Staff: may add/edit/delete any non-School-Admin staff. Deliberately NOT given
    // StaffManageSchoolAdmin, so they can't touch School Admin accounts or promote anyone to one.
    Permission.StaffAdd,
    Permission.StaffEdit,
    Permission.StaffDelete
  ]),

  [Role.Supervisor]: new Set<Permission>([]),
  [Role.Teacher]: new Set<Permission>([]),
  [Role.Security]: new Set<Permission>([]),
  [Role.SharedGateScanner]: new Set<Permission>([]),
  [Role.Gate]: new Set<Permission>([]),
  [Role.Cafeteria]: new Set<Permission>([]),
};

export function isAllowed(role: Role | null | undefined, permission: Permission): boolean {
  if (!role) return false;
  return !!ROLE_PERMISSIONS[role]?.has(permission);
}

/**
 * Row-level staff rule on top of StaffAdd/Edit/Delete: acting on (or assigning) the
 * School Admin role needs StaffManageSchoolAdmin.
 */
export function canManageStaffRole(role: Role | null | undefined, targetStaffRole: string | null | undefined): boolean {
  if (targetStaffRole !== Role.SchoolAdmin) return true;
  return isAllowed(role, Permission.StaffManageSchoolAdmin);
}
